module.exports = __webpack_public_path__ + "static/media/Hope.5a579b04.jpg";